<template>
  <div>
    <BannerInternoBlog></BannerInternoBlog>
    <div class="blogInterna ui-container" v-if="blog">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="blogInterna__categories">
              <div class="row">
                <router-link :to="{ name: 'BlogTag', params: { slug: tag.slug }}" v-for="(tag,index) in blog.tags" :key="index">
                  <span >
                    {{tag.name}}
                  </span>
                </router-link>
              </div>
            </div>
            <div class="blogInterna__title">
              <h1>
                {{blog.title}}
              </h1>
            </div>
            <div v-if="blog.image" class="blogInterna__image text-center">
              <!-- colocar o título do post no alt e no title da image -->
              <img :src="blog.image" :alt="blog.title" :title="blog.title">
            </div>
            <div class="ui-description lh-36" v-html="blog.description">
            </div>
            <div class="blog__video text-center" v-if="blog.video">
              <div class="row justify-content-center">
                <div class="col-md-9 col-12">
                  <iframe width="100%" height="450" :src="'https://www.youtube.com/embed/'+blog.video"></iframe>
                </div>
              </div>
            </div>
            <div class="blog__gallery" v-if="blog.galleries != ''">
              <ul class="row align-items-center">
                <li class="col-md-3 col-12" v-for="(item,index) in blog.galleries" :key="index" @click="openViewer(index)">
                  <img :src="item.image" :alt="blog.title">
                </li>
              </ul>
            </div>
            <!-- repetir imagens aqui também, pois aqui são as imagens da galeria -->
            <div class="blogImage" v-viewer="{movable: false, title: [1, (image) => `${image.alt}`], scalable: false}" style="display: none;">
              <img v-for="(item,index) in blog.galleries" :key="index" :alt="(item.title ? item.title : ' ')" :src="item.image">
            </div>
            <div class="blogInterna__share">
              <div class="row align-items-center justify-content-between">
                <div class="col-md-2 col-12">
                  <div class="blogInterna__share__title">
                    Compartilhar
                  </div>
                </div>
                <div class="col-lg-2 col-sm-3 col-12">
                  <div class="blogInterna__share__item pop">
                    <!-- colocar os dados da interna nas funções de share, slug titulo etc :D -->
                    <a @click="facebook('http://comcasa.com.br/blog/' + blog.slug)">
                      <i class="fa fa-facebook"></i> Facebook
                    </a>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-3 col-12">
                  <div class="blogInterna__share__item pop">
                    <a @click="linkedin('http://comcasa.com.br/blog/' + blog.slug)">
                      <i class="fa fa-linkedin"></i> Linkedin
                    </a>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-3 col-12">
                  <div class="blogInterna__share__item pop">
                    <a @click="twitter('http://comcasa.com.br/blog/' + blog.slug, blog.title, 'Comcasa')">
                      <i class="fa fa-twitter"></i> Twitter
                    </a>
                  </div>
                </div>
                <div class="col-lg-4 col-md-1 col-12">
                  <div class="blogInterna__share__back text-right">
                    <router-link :to="{name: 'Blog'}" class="pop">
                      <img src="../assets/img/back.png" alt="Voltar"> Voltar
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BannerInternoBlog from './BannerInternoBlog.vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  components: {
    BannerInternoBlog
  },
  computed: {
    ...mapGetters([
      'blog'
    ])
  },
  created () {
    this.$store.dispatch('showBlog', this.$route.params.slug).then(response => {
      document.title = 'Comcasa | ' + response.data.title
    })
  },
  methods: {
    openViewer (id) {
      const viewer = this.$el.querySelector('.blogImage').$viewer
      viewer.view(id)
      viewer.show()
    },
    facebook (s) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + s, '/&display=popup&ref=plugin', 'Pagina', 'STATUS=NO, TOOLBAR=NO, LOCATION=NO, DIRECTORIES=NO, RESISABLE=NO, SCROLLBARS=YES, TOP=10, LEFT=10, WIDTH=770, HEIGHT=200')
    },
    linkedin (s) {
      window.open('https://www.linkedin.com/shareArticle?url=' + s, 'Pagina', 'STATUS=NO, TOOLBAR=NO, LOCATION=NO, DIRECTORIES=NO, RESISABLE=NO, SCROLLBARS=YES, TOP=10, LEFT=10, WIDTH=770, HEIGHT=200')
    },
    twitter (s, a, b) {
      window.open('http://twitter.com/share?text=' + a + ' - Veja em: ' + s + '/&url=URL&counturl=&via=' + b, 'Pagina', 'STATUS=NO, TOOLBAR=NO, LOCATION=NO, DIRECTORIES=NO, RESISABLE=NO, SCROLLBARS=YES, TOP=10, LEFT=10, WIDTH=770, HEIGHT=400')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.ui-description {
  /deep/ p {
    margin-bottom: 10px;
  }
}

.viewer-one-to-one{
  display: none;
}

.blogInterna {
  background: $bgIntern;
  &__categories {
    margin-bottom: 30px;
    padding-left: 10px;
    span {
      background: $primary;
      border-radius: 10px;
      color: white;
      font-size: 14px;
      font-style: italic;
      font-weight: 300;
      margin: 0 5px;
      padding: 5px 10px;
    }
  }
  &__title {
    margin-bottom: 30px;
    h1 {
      color: $primary;
      font-style: italic;
      font-size: 34px;
      font-weight: 600;
      line-height: 34px;
    }
  }
  &__image {
    margin-bottom: 30px;
    img {
      border-radius: 10px;
      box-shadow: 20px 20px 35px 0px rgba(0, 26, 66, 0.2);
    }
  }
  &__share {
    margin-top: 50px;
    &__title {
      color: #9d9d9c;
      font-size: 16px;
    }
    &__item {
      a {
        color: $lead;
        cursor: pointer;
        border: 1px $green solid;
        border-radius: 50px;
        font-size: 16px;
        padding: 8px 30px;
        i {
          color: $green;
          margin-right: 15px;
        }
      }
    }
    &__back {
      a {
        color: $text;
        font-size: 16px;
        font-style: italic;
        font-weight: 600;
      }
      img {
        margin-right: 5px;
        margin-top: -3px;
      }
    }
  }
  @media (max-width: 1200px) {
    &__title {
      h1 {
        font-size: 30px;
      }
    }
    &__share {
      margin-top: 40px;
      &__item {
        a {
          padding: 8px 20px;
        }
      }
    }
  }
  @media (max-width: 991px) {
    &__share {
      margin-top: 30px;
      &__item {
        a {
          padding: 8px 15px;
        }
      }
      &__back {
        img {
          opacity: 0;
        }
      }
    }
  }
  @media (max-width: 767px) {
    &__title {
      h1 {
        font-size: 20px;
      }
    }
    &__share {
      margin-top: 20px;
      &__title {
        margin-bottom: 15px;
        text-align: center;
      }
      &__item {
        margin-bottom: 15px;
        text-align: center;
        width: 100%;
        a {
          float: left;
          padding: 8px 15px;
          width: 100%;
        }
      }
      &__back {
        a {
            width: 100%;
        }
        img {
          opacity: 1;
        }
      }
    }
  }
}
.blog__gallery {
  margin-top: 20px;
  li {
    margin: 10px 0;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    img {
      max-height: 150px;
    }
    &:hover {
      transition: all 0.3s;
      opacity: 0.8;
    }
  }
}
.blog__video {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/BlogInterna.vue